import Loadable from 'react-loadable'

const Homebase = Loadable({
    loader: () => import(/* webpackChunkName: "homebase" */ './homebase'),
    loading: () => null,
})

const HomebaseRoute = () => <Homebase />

export default HomebaseRoute
